import appSettings from '@/app-settings.json';
import { BETA_FEATURES } from '@/constants';
import { betaFeatureConfigValue } from '@/data/data-selectors';
import { useSelector } from 'react-redux';

export function useViolations() {
  const violationsTab = useSelector(
    betaFeatureConfigValue(BETA_FEATURES.violationsTab)
  );
  const isEnabled =
    violationsTab?.enabled && appSettings?.uiConfigPayload?.violationsTab;
  return { isEnabled };
}
